import React from 'react';

const ErrorView = () => {
    return <div className="ac-page">
        <h1>Oops!</h1>
            <p>Sorry, something unexpected happened.</p>
            <p>Please start over and try again. If this issue persists, please email <a href="mailto:support@aptcrowd.co">support@aptcrowd.co</a>.</p>
    </div>
}

export default ErrorView;